exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conditions-table .condition-row.selected {\n  background-color: rgba(250, 219, 20, 0.1);\n}\n.conditions-table .condition-row.selected:hover > td {\n  background: transparent !important;\n}\n.conditions-table .priority-container,\n.conditions-table .priority-input {\n  width: 90px;\n}\n.conditions-table .cell-limited-max-width {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 350px;\n}\n.conditions-table .exclamation-icon {\n  color: #b80c02;\n  font-size: 18px;\n}\n", ""]);

// exports
